// export const swapContract = "0x42e3c302F9952c9c6c7230F9EbA494444AE1F3ff"; //dev
export const swapContract = "0x2d040A9454abcd4740a020F40758Cbe025EdF2d2"; // sir main wallet live

// export const swapContract = "0x7f869abEEf437821B4F464839f6F36754939c57F"; //local testing

// export const swapContract = "0xFA7AB15C7656a1EbFEde15CF730468312ba23a61"; //test.powdex.io

// export const swapContract = "0x36d96f4bFc91d0d4A8cCD24A2fc471d107FD2703"; //dev
